
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LineCharts, { type LineChartsConfig } from './charts/LineCharts.vue'
import BarCharts, { type BarChartsConfig } from './charts/BarCharts.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LineCharts,
    BarCharts
  }
})
export default class SummaryStudyData extends Vue {
  lineChartsConfig: LineChartsConfig = {
    lineWidth: 3,
    lineColor: '#E0BF95',
    fillColor: '#F9EDDD',
    containerW: 278,
    containerH: 98,
    bottomRaduis: 4
  }
  barChartsConfig: BarChartsConfig = {
    barWidth: 5,
    totalColor: '#F0E1CE',
    completedColor: '#E0BF95',
    barRadius: 1,
    containerW: 278,
    containerH: 100
  }

  get PageStore() {
    return this.$store.$courseV2.Summary
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
